import type { ShareServiceConfig } from "../../../shared/index.js";

export const linkedin: ShareServiceConfig = {
  link: "https://www.linkedin.com/sharing/share-offsite/?url=[url]",
  color: "#4376B1",
  shape:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M912 598v297H740V618c0-69-24-117-86-117-48 0-76 32-89 63-4 11-5 27-5 42v289H388s3-469 0-517h172v72l-1 3h1v-3c23-35 63-84 155-84 113 0 197 74 197 232M209 130c-59 0-97 37-97 88 0 50 37 90 95 90h1c60 0 97-40 97-90-1-51-37-88-96-88m-87 765h171V378H122z"/></svg>',
};
